import { render, staticRenderFns } from "./CompensatoryLeavesDashboard.vue?vue&type=template&id=da55a040&scoped=true"
import script from "./CompensatoryLeavesDashboard.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesDashboard.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryLeavesDashboard.vue?vue&type=style&index=0&id=da55a040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da55a040",
  null
  
)

export default component.exports